<template>
  <div class="page">
    <div class="layout">
      <el-row type="flex" align="middle" justify="space-between">
        <el-col :span="12">
          <div class="page-title">練習列表</div>
        </el-col>
        <el-col :span="4" style="text-align: right;">
          <el-button type="info" v-if="userInfoRoleRoleId !== teacherRoleId" @click.native="onAdd">新增練習</el-button>
        </el-col>
      </el-row>

      <div class="page-box">
        <div class="page-content-box">
          <div class="page-content-row">
            <div>
              <div class="search-text">練習編號</div>
              <el-input
                v-model="formLabelAlign.numberLike"
                placeholder="練習編號"
              ></el-input>
            </div>
            <div>
              <div class="search-text">語言</div>
              <el-select v-model="formLabelAlign.lang" placeholder="請選擇語言">
                <el-option
                  v-for="item in languages"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div>
              <el-button type="info" @click="onSearch" class="button-el-el">搜尋</el-button>
            </div>
            <div>
              <el-button type="success" @click="onReset" class="button-el-el">清除篩選</el-button>
            </div>
          </div>
        </div>
        <el-table
          @sort-change="handleSortChange"
          :data="tableData"
          style="width: 100%;"
        >
          <el-table-column
            prop="number"
            label="練習編號"
            align="center"
            sortable="custom"
          >
          </el-table-column>
          <el-table-column
            label="描述"
            align="center"
            width="200px"
          >
            <template slot-scope="{row}">
              <div class="describe-text" v-if="row.desc">{{ row.desc }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="lang"
            label="語言"
            align="center"
          >
          <template slot-scope="{row}">
                <span>{{row.lang | language}}</span>
          </template>
          </el-table-column>
           <el-table-column
             prop="updatedAt"
            label="最後更新時間"
            align="center"
            sortable="custom">
           <template slot-scope="{row}">
               <span>{{row.updatedAt | formatDateTime}}</span>
           </template>
          </el-table-column>
          <el-table-column
            prop="editor"
            label="最後更新帳號"
            align="center">
           <template slot-scope="{row}">
               <span>{{row.editor}}</span>
           </template>
          </el-table-column>
          
          <el-table-column label="操作" align="center">
            <template slot-scope="{ row }">
              <el-button v-if="userInfoRoleRoleId !== teacherRoleId" type="text" size="medium" @click="onEditButton(row.id)"
                >編輯</el-button
              >
              <el-button v-if="userInfoRoleRoleId !=teacherRoleId && userInfoRoleRoleId !=editorRoleId" type="text" size="medium" @click="onDeleteButton(row.id)"
                >刪除</el-button
              >
              <el-button
                type="text"
                size="medium"
                @click="onDetailButton(row.id)"
                >詳情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <Pagination
      v-show="total > 0"
      :total="total"
      :page.sync="formLabelAlign._page"
      :limit.sync="formLabelAlign._limit"
      @pagination="getPractises"
    />
    <deleteDialog
      titleCh="您確定要將此練習刪除嗎?"
      :centerDialogVisible="centerDialogVisible"
      @confirmFunction="confirmFunction"
      @onCancelButton="onCancelButton"
    ></deleteDialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { getPractises ,deletePractise } from "@/api/practises";
import deleteDialog from "@/components/deleteDialog";
export default {
  components: { deleteDialog, Pagination },
  data() {
    return {
      total: 0,
      orderId: null,
      dialogSlotVisible: false,
      centerDialogVisible: false,
      formLabelAlign: {
        numberLike: null,
        lang: null,
        topicId: null,
        orderBy: null,
        _page: 1,
        _limit: 50,
      },
      tableData: [],
    };
  },
  created() {
    this.getPractises();
  },
  methods: {
    handleSortChange(column) {
      if (column.order === "descending") {
        this.formLabelAlign.orderBy = column.prop + " desc";
      } else if (column.order === "ascending") {
        this.formLabelAlign.orderBy = column.prop + " asc";
      } else {
        this.formLabelAlign.orderBy = null;
      }
      this.formLabelAlign._page = 1;
      this.getPractises();
    },
    onReset() {
      Object.keys(this.formLabelAlign).forEach((key) => {
        this.formLabelAlign[key] = null;
        if(key === "_page"){
          this.formLabelAlign[key] = 1;
        }else if(key === "_limit"){
          this.formLabelAlign[key] = 50;
        }
      })
      this.getPractises();
    },
    onSearch() {
      this.getPractises();
    },
    onCancelButton() {
      this.centerDialogVisible = false;
    },
    confirmFunction() {
      this.deletePractise();
    },
    onAdd() {
      let path = `/practice/add`;
      this.resolveRouter(path)
    },
    onEditButton(id) {
      let path = `/practice/${id}/edit`;
      this.resolveRouter(path)
    },
    onDetailButton(id) {
      let path = `/practice/${id}`;
      this.resolveRouter(path)
    },
    deletePractise(){
      deletePractise(this.orderId).then(()=>{
        this.$message.success("删除成功");
        this.getPractises();
      }).finally(()=>{
        this.centerDialogVisible = false;
      })
    },
    onDeleteButton(id) {
      this.orderId = id;
      this.centerDialogVisible = true;
    },
    getPractises() {
      let formLabelAlign = {
        numberLike: this.formLabelAlign.numberLike,
        lang: this.formLabelAlign.lang,
        topicId: this.formLabelAlign.topicId,
        orderBy: this.formLabelAlign.orderBy,
        _page: this.formLabelAlign._page - 1,
        _limit: this.formLabelAlign._limit,
      };
      getPractises(formLabelAlign).then((v) => {
        this.tableData = v.data;
        this.total = Number(v.headers["x-total-count"]);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  .layout {
    .el-row {
      padding: 20px;
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }

      .title {
        font-size: 30px;
      }
    }

    .el-button--text {
      color: #166ea5;
      font-size: 16px;
    }
  }
}
.page-box {
  background-color: #fff;
}
.button-el-el {
  width: 100%;
  margin-top: 23px;
}
.page-content-box{
  width: 100%;
  overflow-x: auto;
}
.page-content-row {
    display: grid;
    padding: 20px;
    grid-template-columns: repeat(6, 170px);
    grid-template-rows: repeat(1, 1fr);
    gap: 8px;
    align-items: end;
}
.page-content-row>div{
  min-width: 170px !important;
}
.page-content-row>div:nth-last-child(1), .page-content-row>div:nth-last-child(2){ 
  width: 100px !important;
}
.describe-text{
  display: -webkit-box; /* 使用弹性盒子布局 */
  -webkit-box-orient: vertical; /* 垂直方向排列 */
  -webkit-line-clamp: 3; /* 最多显示三行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  line-height: 1.5; 
}
</style>